import { put } from "redux-saga/effects";
import logger from "lib/log";

import { fatalError } from "state/app/actions";
import { setCheckoutError } from "state/school_money/actions";

/**
 * When we get a paysafe error, log the details and recover or die.
 */
export default function* handlePaysafeErrorSaga(action) {
  
  const { error } = action.payload;
  logger.warn("Paysafe API error", error.originalError);
  
  const isRecovering = yield* recover(error);
  if (!isRecovering) {
    yield put(fatalError(error));
  }
  
}

/**
 * Detect non-fatal errors and dispatch actions that may allow
 *   them to be handled gracefully.
 * @returns {boolean} `true` if error is recoverable, `false` otherwise
 */
function* recover({ stage, originalError }) {
  switch (originalError.code) {
    case "9001":
    case "9002":
      yield put(setCheckoutError("ERROR_CONNECTION"));
      return true;
    case "9003":
      yield put(setCheckoutError("ERROR_INVALID_FIELDS"));
      return true;
    case "9037":
      yield put(setCheckoutError("ERROR_3DS_CONNECTION"));
      return true;
    case "9039":
    case "9040":
    case "9042":
      yield put(setCheckoutError("ERROR_3DS_FAILED"));
      return true;
    default:
      return false;
  }
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/handlePaysafeErrorSaga.js